exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-customer .el-form{gap:0.52083rem;display:flex;align-items:flex-end}.new-customer .el-radio-button__inner{width:1.5625rem}.new-customer .export-button{position:absolute;right:0}.el-input__inner{height:0.16667rem !important}\n", ""]);

// exports
